import React, { useState, useEffect, useContext, createContext } from 'react';
import { getRequest } from 'utils/helper';
import { ErrorPage } from '../routes/ErrorPage';

type uiContextType = {
  loading: any;
  data: any;
  genericKeyValues: any;
};

export const UIContext = createContext<uiContextType>({
  loading: true,
  data: {},
  genericKeyValues: {}
});
export const useUIContext = (): uiContextType => useContext(UIContext);

export const UIContextProvider = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [navigationAppsList, setNavigationAppsList] = useState({});
  const [loading, setLoading] = React.useState(true);
  const [genericKeyValues, setGenericKeyValues] = useState({});
  const [showErrorPage, setShowErrorPage] = useState<boolean>(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        const res = await getRequest(
          '/integration-settings-api/ui-context',
          {},
          false
        );
        if (res.data) {
          const {
            isEditIntegrationPermission,
            logoutUrl,
            redirection403Url
          } = res.data;
          if (!isEditIntegrationPermission) {
            window.location.href = redirection403Url;
          }
          if (logoutUrl) {
            window.location.href = logoutUrl;
          }
          setNavigationAppsList(res.data);
          setGenericKeyValues(res.data.keyValues);
          setLoading(false);
        }
      } catch (error: any) {
        if (error.response) {
          setShowErrorPage(true);
        }
      }
    };
    initialize();
  }, [setNavigationAppsList]);

  const value = {
    loading: loading,
    data: navigationAppsList,
    genericKeyValues: genericKeyValues
  };

  return showErrorPage ? (
    <ErrorPage open={true} />
  ) : (
    <UIContext.Provider value={value}>{children}</UIContext.Provider>
  );
};
